<template>

    <div class="layout justify-center wrap container text-xs-center">

        <v-flex class="xs12 sm6 md3">
            <div class="general-card">
                <v-card class="card card-plain">
                    <FileInfo v-if="loadComponents"  v-on:loaded="loading=false"  :hash="file.hash" :token="token"></FileInfo>
                </v-card>
            </div>

            <v-btn v-if="!loading" round center color="primary" dark @click="goToViewer">{{$t("View")}}</v-btn>
        </v-flex>

        <v-flex class="xs12 sm6 md8">
            <FileHistory ref="file_history" :canRevoke="true" :canEdit="true" :hash="this.file.hash" :token="this.token" title></FileHistory>
        </v-flex>

    </div>
</template>

<script>

    import { VFlex, VBtn, VCard, VTimeline, VTimelineItem, VCardTitle, VChip, VProgressCircular} from 'vuetify/lib';
    import FilesRepository from '../repositories/FilesRepository';
    import LocalRepository from '../repositories/LocalRepository';
    import FileInfo from "../components/FileInfo";
    import FileHistory from "../components/FileHistory";

    export default {
        name: 'Tracker',
        components: {
            VFlex,
            VCard,
            VBtn,
            VTimeline,
            VTimelineItem,
            VCardTitle,
            VChip,
            VProgressCircular,
            FileInfo,
            FileHistory
        },
        created() {
            // Check if we have a token in header
            if (this.$route.params.token) {
                this.token = this.$route.params.token;
                this.logout();
            }

            // Load the file info
            this.file.hash = this.$route.params.hash;
            this.checkTrackerAccess();
        },
        data: () => ({
            loadComponents: false,

            // General loading
            loading: true,

            // The token in url
            token: null,
            file: {
                hash: "",
                name: "",
                type: "",
                size: 0,
                creatorEmail: "",
                creationDate: ""
            }
        }),
        methods:{
            getFileDetails() {
                FilesRepository.getFileDetails(this.$route.params.hash, this.token)
                    .then((response)=>{
                        if (response && response.data && response.data.file && response.data.file.actions){
                            this.$refs.file_history.setItems(response.data.file.actions);
                        }
                    })
                    .catch((e)=>{
                        console.error(e);
                    })
                    .finally(()=>{
                        this.loading = false;
                    });
            },
            checkTrackerAccess() {
                FilesRepository.checkTrackerAccess(this.$route.params.hash, this.token)
                    .then(()=>{
                        this.loadComponents = true;
                        this.getFileDetails();
                    }).catch((error)=>{
                        this.$router.push({name: 'error', params: {message: error.response.data.message}});
                    });
            },
            goToViewer() {
                if (this.token) {
                    this.$router.push({name: 'viewer', params: {hash: this.file.hash, token: this.token}});
                } else {
                    this.$router.push({name: 'viewer-logged', params: {hash: this.file.hash}});
                }
            },
            logout() {
                LocalRepository.clear("token");
                this.$user = null;
            }
        }
    };
</script>

<style scoped>
    .general-card{
        padding-left: 10px;
        padding-right: 10px;
    }
</style>
